import { render } from "./order-table-page.vue?vue&type=template&id=b151be4e&scoped=true"
import script from "./order-table-page.vue?vue&type=script&lang=js"
export * from "./order-table-page.vue?vue&type=script&lang=js"

import "./order-table-page.vue?vue&type=style&index=0&id=b151be4e&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b151be4e"]])

export default __exports__